import { format, getDay } from 'date-fns';
import i18n, { isJa } from '@/settings/i18n';

export const isNewAndEditAndCancelOfEmba2Ended = (): boolean => {
  return new Date() >= new Date('2026-04-30T00:00:00+09:00');
};

export const weekDayDateFormat = ({
  date,
  withWeekDay = true,
  suffix = '',
}: {
  date: string;
  withWeekDay?: boolean;
  suffix?: string;
}) => {
  const dateTime = date ? new Date(date) : '';
  const dateText = dateTime
    ? format(dateTime, i18n.t('ui.locale.literalDateFormat'))
    : '';
  const weekDayText =
    withWeekDay && dateTime
      ? `(${i18n.t(`ui.weekdayShort.${getDay(dateTime)}`)})`
      : '';

  return dateText + weekDayText + suffix;
};

/**
 * 複数の開講日がある場合は、一番早い日付に~をつけて表示する
 * 日付順にAPI側でソートされており、配列の先頭に一番早い日付が入っている
 */
export const startDateFormat = ({
  date,
  withWeekDay,
}: {
  date: string[];
  withWeekDay?: boolean;
}) => {
  const suffix =
    date.length >= 2 ? `${!isJa() ? ' ' : ''}${i18n.t('ui.range')}` : '';
  return weekDayDateFormat({ date: date[0], withWeekDay, suffix });
};
